<template>
    <div class="element--locations">
        <section class="locations">

            <div class="locations-filter" ref="locationFilterRef" :class="{collapsed: !isFilterExpanded, sticky: isFilterSticky}">
                <div class="container">
                    <div class="row" v-show="!isFilterSticky || isFilterExpanded">
                        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                            <form-input
                                v-model="locationName"
                                :value="locationName"
                                id="location--your-address"
                                label="Enter your address"
                                type="text"
                                :isLocationAutocomplete="true"
                                @locationSelected="setAutocompleteLocation"
                                @locationUpdated="locationUpdated"
                            ></form-input>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                            <form-select
                                value="0"
                                @change="projectOnChange"
                                id="suplier--project-type"
                                label="Select your project type"
                                :staticOptions="true"
                                :allowEmpty="false"
                                :options="mapOptionsData(filteredProjectTypes)"
                            ></form-select>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                            <form-select
                                value="0"
                                @change="serviceOnChange"
                                id="suplier--service-type"
                                label="Select service required"
                                :staticOptions="true"
                                :allowEmpty="false"
                                :options="mapOptionsData(filteredServiceTypes)"
                            ></form-select>
                        </div>

                        <div class="col-xs-12">
                            <a href="#" @click.prevent="getUserGeolocation" class="get-my-location">Use my location</a>
                        </div>

                        <div class="col-xs-12">
                            <button class="button button--solid-black start-search" @click="initiateFiltering">Search</button>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xs-12">
                            <div class="filter-wrapper--toggle">
                                <div
                                    class="toggle"
                                    @click="toggleExpandFilter"
                                >
                                    <p>
                                        Filters
                                    </p>
                                    <span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="9" viewBox="0 0 14 9" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.00024 8.99994L0.000244141 1.13342L1.00805 -6.10352e-05L7.01615 6.78355L13.0083 0.0178985L14.0002 1.13342L7.00024 8.99994Z" fill="black"/>
                                        </svg>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-show="isFilterSticky" class="locations-filter--holder" ref="locationFilterHolderRef"></div>


            <div class="locations-map space--lg" id="location-map-container">

                <GMapMap
                    ref="supplierMap"
                    :center="mapCenter"
                    :zoom="mapZoom"
                    :options="options"
                    style="width: 100%; height: 100%"
                >
                    <GMapCluster
                        :zoomOnClick="true"
                        :styles="[
                            {
                                url: '/_resources/themes/colorsteel/dist/assets/images/map/marker-blank.svg',
                                textColor: 'black',
                                height: 50,
                                width: 42
                            }
                        ]"
                    >
                        <GMapMarker
                            :key="index"
                            v-for="(m, index) in filteredData"
                            :position="m.position"
                            :clickable="true"
                            :draggable="false"
                            :icon="{
                                url: '/_resources/themes/colorsteel/dist/assets/images/map/marker.svg',
                                size: {width:42, height:50},
                                origin: {x:0, y:0},
                                anchor: {x:21, y:50},
                                scaledSize: {width:42, height:50}
                            }"

                            @click="toggleInfoWindow(m,null)"
                        />
                    </GMapCluster>

                    <GMapMarker
                        v-if="locationLatLng!==null"
                        :position="locationLatLng"
                        :clickable="false"
                        :draggable="false"
                        :icon="{
                            url: '/_resources/themes/colorsteel/dist/assets/images/map/dot.png?v2',
                            size: {width:60, height:60},
                            origin: {x:0, y:0},
                            anchor: {x:3, y:3},
                            scaledSize: {width:6, height:6}
                        }"
                    ></GMapMarker>

                    <GMapInfoWindow
                        @closeclick="infoWinOpen = false"
                        :closeclick="true"
                        :opened="infoWinOpen"
                        :position="infoWindowPos"
                        :options="{
                            pixelOffset: infowindowPixelOffset
                        }"
                    >
                        <div class="location" v-if="infoWindowData!==null">

                            <h4 class="medium">{{infoWindowData.title}}</h4>
                            <div v-if="infoWindowData.city" class="region medium">{{ infoWindowData.city }}</div>

                            <div class="grouped">
                                <div class="service" v-if="objectListToArray(infoWindowData.serviceTypes).length>0">
                                    <span
                                        v-for="(service, index) in infoWindowData.serviceTypes"
                                        :key="index"
                                    >{{service.title}}</span>
                                </div>

                                <div class="address" v-if="infoWindowData.address">
                                    {{infoWindowData.address}}
                                </div>
                                <div class="phone" v-if="infoWindowData.number">
                                    <a :href="'tel:' + infoWindowData.number" >
                                        {{infoWindowData.number}}
                                    </a>
                                </div>
                                <div class="email" v-if="infoWindowData.email">
                                    <a :href="'mailto:' + infoWindowData.email" >
                                        {{infoWindowData.email}}
                                    </a>
                                </div>
                            </div>


                            <div class="website" v-if="infoWindowData.website">
                                <a
                                    class="medium"
                                    :href="infoWindowData.website"
                                    :title="'Visit the ' + infoWindowData.title + ' website'"
                                    :aria-label="'Visit the ' + infoWindowData.title + ' website'"
                                    target="_blank"
                                >
                                    Visit website
                                </a>
                            </div>

                        </div>
                    </GMapInfoWindow>
                </GMapMap>

            </div>


            <div v-if="displayedData.length>0" class="locations-list space--lg">
                <div class="container">
                    <div class="row">
                        <div
                            v-for="(item) in displayedData"
                            :key="item.id"
                            :id="item.code"
                            class="supplier-list_item col col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4"
                        >
                            <div class="location">

                                <h4
                                    class="medium"
                                    @click="toggleInfoWindow(item,true,16)"
                                >{{item.title}}</h4>
                                <div v-if="item.city" class="region medium">{{ item.city }}</div>

                                <div class="grouped">
                                    <div class="service" v-if="objectListToArray(item.serviceTypes).length>0">
                                        <span
                                            v-for="(service, index) in item.serviceTypes"
                                            :key="index"
                                        >{{service.title}}</span>
                                    </div>
                                    <!-- <div class="project-type" v-if="objectListToArray(item.projectTypes).length>0">
                                        <span
                                            v-for="(project, index) in item.projectTypes"
                                            :key="index"
                                        >{{project.title}}</span>
                                    </div> -->


                                    <div class="address" v-if="item.address">
                                        {{item.address}}
                                    </div>
                                    <div class="phone" v-if="item.number">
                                        <a :href="'tel:' + item.number" >
                                            {{item.number}}
                                        </a>
                                    </div>
                                    <div class="email" v-if="item.email">
                                        <a :href="'mailto:' + item.email" >
                                            {{item.email}}
                                        </a>
                                    </div>
                                </div>


                                <div class="website" v-if="item.website">
                                    <a
                                        class="medium"
                                        :href="item.website"
                                        :title="'Visit the ' + item.title + ' website'"
                                        :aria-label="'Visit the ' + item.title + ' website'"
                                        target="_blank"
                                    >
                                        Visit website
                                    </a>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container">
                <div class="row">
                    <div class="col-xs-12">
                        <div class="text-center">
                            <div v-if="dataToShow < filteredData.length">
                                <button
                                    class="button button--solid-black"
                                    @click="handleShowMoreClick()"
                                >
                                    Load More
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </section>
    </div>
</template>

<script>

//const mapMarker = require('../../../assets/images/icons/marker.svg');
// import { Fragment } from 'vue-fragment';

import { debounce } from 'vue-debounce'
import { getDistance } from '../../helpers/distance.js'

export default {
    name: "locations",
    components: {
        // Fragment
    },
    props: {
        data: {
            type: Array,
            required: true
        },
        projectTypes: {
            // type: Array,
            required: true
        },
        serviceTypes: {
            // type: Array,
            required: true
        },
        totalSuppliers: {
            type: Number,
            required: true
        }
    },
    data: function () {
        return {
            center: {lat: 51.093048, lng: 6.842120},
            markers: [
                {
                    position: {
                        lat: 51.093048, lng: 6.842120
                    }
                }
            ],

            doFocusOnly: false,
            projectType: "0",
            serviceType: "",
            locationName: null,
            locationLatLng: null,

            filterData: {
                address: null,
                addressLatLng: null,
                project: "",
                service: ""
            },
            filteredData: [],
            displayedData: [],
            dataToShow: 9,

            //markers: [],
            place: null,
            options: {
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
                // zoom: 6,
                // disableDefaultUI: true,
                // scrollwheel: true,
                styles: [
                    {
                        "featureType": "all",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "saturation": "0"
                            },
                            {
                                "color": "#d0d0d0"
                            },
                            {
                                "lightness": "0"
                            }
                        ]
                    },
                    {
                        "featureType": "all",
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#636363"
                            },
                            {
                                "lightness": "0"
                            }
                        ]
                    },
                    {
                        "featureType": "all",
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "lightness": 20
                            }
                        ]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "color": "#000000"
                            },
                            {
                                "lightness": "0"
                            },
                            {
                                "weight": 1.2
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#646464"
                            },
                            {
                                "lightness": "0"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#646464"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#5d5d5d"
                            },
                            {
                                "lightness": "0"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#838383"
                            },
                            {
                                "lightness": "0"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "lightness": "0"
                            },
                            {
                                "weight": 0.2
                            },
                            {
                                "color": "#838383"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#737373"
                            },
                            {
                                "lightness": "0"
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#676767"
                            },
                            {
                                "lightness": "0"
                            }
                        ]
                    },
                    {
                        "featureType": "transit",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#737373"
                            },
                            {
                                "lightness": "0"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#4c4c4c"
                            },
                            {
                                "lightness": "0"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#4c4c4c"
                            }
                        ]
                    }
                ]
            },

            infoWindowPos: null,
            infoWinOpen: false,
            currentMidx: null,
            infoWindowData: null,

            mapCenter: {
                lat:-41.3129342174007,
                lng:174.27977731919526
            },
            mapZoom: 5,
            infowindowPixelOffset: null,
            iconImage: null,
            keywordFieldWidth: null,
            resizeEventEnabled: false,
            userGeolocation: null,
            isFilterSticky: false,
            isFilterExpanded: true,
            scrollTicking: false,
            prevWindowPosY: 0,
        }
    },
    methods: {
        locationUpdated(payload){
            this.locationName = payload;
        },
        resizeHandlerEvent() {},
        resizeHandler () {
            const html = document.documentElement;
            if(html.clientWidth<768) {
                this.infowindowPixelOffset = {
                    width: 0,
                    height: -60
                }
            }else{
                this.infowindowPixelOffset = {
                    width: -198,
                    height: 83
                }
            }
        },

        sortByDistance(resultData){
            if(this.locationLatLng!==null){
                resultData.forEach((data, index) => {
                    resultData[index].distance = getDistance(
                        { latitude: this.locationLatLng.lat, longitude: this.locationLatLng.lng },
                        { latitude: data.position.lat, longitude: data.position.lng }
                    );
                });
            }

            resultData.sort(function(a, b) {
                if (a.distance < b.distance) return -1;
                if (a.distance > b.distance) return 1;
                return 0;
            });

            return resultData;
        },

        objectListToArray(obj, dataKey='title', wholeObj=false){
            let arr = [];
            for (const key in obj) {
                if(wholeObj){
                    arr.push(obj[key]);
                }else{
                    arr.push(obj[key][dataKey]);
                }
            }
            return arr;
        },

        getUserGeolocation(){
            var app = this;
            // const supplierMap = this.$refs.supplierMap;

            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function(position) {
                    const pos = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };

                    const geocoder = new window.google.maps.Geocoder();
                    geocoder
                        .geocode({ location: pos })
                        .then((response) => {
                            if (response.results[0]) {
                                app.locationName = response.results[0].formatted_address;
                                app.locationLatLng = pos;

                                app.doFocusOnly = true;
                                app.mapPanTo(pos, 12, true);
                                app.setFilteredData();

                            }
                        })
                        .catch((e) => window.alert("Geocoder failed due to: " + e));
                }, function() {
                    // error getting location
                }, {
                    maximumAge: 5000,
                    timeout: 10000,
                    enableHighAccuracy: true
                });
            } else {
                // Browser doesn't support Geolocation
            }
        },

        mapFitBound(markerData, checkAddressField=false) {
            if(this.google!==null){
                var bounds = new window.google.maps.LatLngBounds();
                markerData.forEach((data) => {
                    if(data.position.lng!==0) bounds.extend(data.position);
                });

                this.$refs.supplierMap.$mapPromise.then((map) => {
                    if(checkAddressField && this.filterData.addressLatLng!==null){
                        if(markerData[0].distance>5){
                            this.mapPanTo(markerData[0].position, 11, true);
                        }else{
                            this.mapPanTo(this.filterData.addressLatLng, 14, true);
                        }
                    }else{
                        let curentZoom = map.getZoom();
                        map.fitBounds(bounds);
                        let tgZoom = map.getZoom();

                        if(curentZoom!==tgZoom){
                            map.setZoom(tgZoom-2);
                            setTimeout(()=>{
                                map.setZoom(tgZoom);
                            }, 500);
                        }
                    }
                });
            }
        },

        mapPanTo(position, tgZoom, forceZoom=false){
            this.$refs.supplierMap.$mapPromise.then((map) => {
                map.panTo(position);
                let cZoom = map.getZoom();

                if(forceZoom && cZoom!==tgZoom){
                    map.setZoom(tgZoom);
                }else{
                    if(map.getZoom()<tgZoom){
                        map.setZoom(tgZoom);
                    }
                }
            });
        },
        setAutocompleteLocation(payload){
            let position = {lat: payload.location.wgs84_lat, lng: payload.location.wgs84_lon};
            this.locationLatLng = position;
        },
        setPlace(place) {
            this.place = place;
            this.locationName = place.formatted_address;

            let position = {lat: place.geometry.location.lat(), lng: place.geometry.location.lng()};
            this.locationLatLng = position;

            if(
                this.filterData.project!=="" ||
                this.filterData.service!==""
            ){
                this.initiateFiltering();
            }else{
                this.mapPanTo(position, 12, true);
                this.setFilteredData();
            }
        },

        toggleInfoWindow(marker, scrollTo, zoom=14) {
            let position = {lat: parseFloat(marker.latitude), lng: parseFloat(marker.longitude)};

            this.infoWindowPos = position;
            this.infoWindowData = marker;
            this.infoWinOpen = true;

            if(scrollTo===true){
                this.$scrollTo('#location-map-container', 500);
            }

            if (!this.resizeEventEnabled) {
                this.resizeEventEnabled = true;
                this.$refs.supplierMap.$mapPromise.then((map) => {
                    map.addListener("zoom_changed", () => {
                        if(map.getZoom()<=8 && this.infoWinOpen){
                            this.infoWinOpen = false;
                        }
                    });
                });
            }
        },

        initiateFiltering(){
            // this.projectType = ID
            // this.serviceType = ID

            this.filterData = {
                address: this.locationName,
                addressLatLng: this.locationLatLng,
                project: this.projectType=='0' ? "" : this.projectType,
                service: this.serviceType=='0' ? "" : this.serviceType
            };
            this.setFilteredData();
        },

        setServiceType: function (serviceTypeID) {

        },

        findProjectTypeName: function (projectTypeID) {
            return this.projectTypes.find(projectType => projectType.projectTypeID === projectTypeID).name;
        },

        setFilteredData(){
            var app = this;
            let resultData = this.data;

            let sortOnly = false;
            if(
                this.filterData.address===null &&
                this.filterData.addressLatLng===null &&
                this.filterData.project==="" &&
                this.filterData.service===""
            ){
                sortOnly = true;
            }

            if(!sortOnly) {

                if (this.filterData.project) {
                    resultData = resultData.filter((item) => {
                        let idArr = this.objectListToArray(item.projectTypes, 'id');
                        return idArr.indexOf(parseInt(this.filterData.project)) >= 0;
                    });
                }

                if (this.filterData.service) {
                    resultData = resultData.filter((item) => {
                        let idArr = this.objectListToArray(item.serviceTypes, 'id');

                        return idArr.indexOf(parseInt(this.filterData.service)) >= 0;
                    });
                }
                resultData = this.sortByDistance(resultData);

                if(resultData.length>0){
                    this.mapFitBound(resultData, true);
                }
            } else {
                resultData = this.sortByDistance(resultData);

                if(!this.doFocusOnly){
                    app.$refs.supplierMap.$mapPromise.then((map) => {
                        app.mapFitBound(app.data, false);
                    });
                }else{
                    this.mapPanTo(this.locationLatLng, 14, true);
                    this.doFocusOnly = false;
                }
            }

            this.dataToShow = 9;
            this.filteredData = resultData;
            this.displayedData = resultData.slice(0, this.dataToShow);

            if(this.filteredData.length<=0){
                setTimeout( () => {
                    app.$refs.supplierMap.$mapPromise.then((map) => {
                        map.setZoom(this.mapZoom);
                        map.setCenter(this.mapCenter);
                    });
                }, 500);
            }
        },

        mapOptionsData(data){
            let obj = {'0' : 'All'};

            let mapped = data.map((item,index) => {
                obj[item.id] = item.name;
                return obj;
            });

            return obj;
        },
        projectOnChange(value){
            this.projectType = value;
        },
        serviceOnChange(value){
            this.serviceType = value;
        },

        handleShowMoreClick() {
            this.dataToShow += 9

            const _filteredData = this.convertItemsObjToArray(this.filteredData)
            const slicedArray = _filteredData.slice(0, this.dataToShow)
            console.log(slicedArray)

            this.displayedData = slicedArray
        },
        toggleExpandFilter() {
            this.isFilterExpanded = !this.isFilterExpanded
        },
        onScrollHandler() {
            if (!this.scrollTicking) {
                window.requestAnimationFrame(() => {
                    const windowPosY = window.scrollY;
                    const filterPosY = this.$refs.locationFilterRef.offsetTop;
                    const filterHolderPosY = this.$refs.locationFilterHolderRef.offsetTop;
                    const navbarHeight = document.querySelector('.profile-links')?.offsetHeight || 0;

                    // set sticky
                    if ((windowPosY + navbarHeight) > ((filterHolderPosY || filterPosY) + (this.$refs.locationFilterHolderRef.offsetHeight || this.$refs.locationFilterRef.offsetHeight))) {
                        this.isFilterSticky = true;
                    } else {
                        this.isFilterSticky = false;
                        this.$refs.locationFilterHolderRef.style.height = `${this.$refs.locationFilterRef.offsetHeight}px`
                    }

                    // set autocollapse
                    if (this.isFilterSticky && this.prevWindowPosY < windowPosY) {
                        this.isFilterExpanded = false;
                    }
                    this.prevWindowPosY = windowPosY;

                    this.scrollTicking = false;
                });

                this.scrollTicking = true;
            }
        },
    },

    computed: {
        // google: gmapApi,

        filteredServiceTypes: function () {
            return this.objectListToArray(this.serviceTypes, null, true);
        },

        filteredProjectTypes: function () {
            return this.objectListToArray(this.projectTypes, null, true);
        }
    },
    mounted() {
        var app = this;

        app.filteredData = this.convertItemsObjToArray( app.data );
        app.displayedData = this.convertItemsObjToArray( app.data ).slice(0, app.dataToShow);

        app.$refs.supplierMap.$mapPromise.then((map) => {
            app.mapFitBound(app.data, false);
        });

        window.addEventListener('scroll', this.onScrollHandler);

        app.resizeHandler();
    },
    created(){
        const app = this;
        app.resizeHandlerEvent = debounce(function(){
            app.resizeHandler();
        }, 250);
        window.addEventListener("resize", this.resizeHandlerEvent)
    }
};
</script>

<style lang="scss" scoped>
    @import "../../../scss/abstracts/variables";

    .profile-links--visible {
        .locations-filter.sticky {
            top: 61px;
            padding-top: 54px;

            @media #{$hd} {
                padding-top: 20px;
            }
        }
    }

    .locations-filter {
        background-color: #fffefa;
        z-index: 20;

        &.sticky {
            box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
            position: fixed;
            top: 0;
            margin-top: -1px !important;
            padding-top: 60px;
            width: 100%;

            @media #{$hd} {
                padding-top: 20px;
            }

            .filter-wrapper--toggle {
                display: flex;
                justify-content: center;
                margin-top: 24px;
                margin-bottom: 20px;

                .toggle {
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    gap: 7px;
                }

                p {
                    margin: 0;
                }

                span {
                    transition: transform 250ms ease-in-out;
                    transform: rotate(180deg);
                }
            }
        }

        &.sticky.collapsed {
            padding-top: 0;

            .filter-wrapper--toggle {
                margin-top: 29px;
                margin-bottom: 29px;

                @media #{$hd} {
                    margin-top: 16px;
                    margin-bottom: 16px;
                }

                span {
                    transform: rotate(0deg);
                }
            }
        }

        .filter-wrapper--toggle {
            display: none;
        }
    }

    .locations-filter--holder {
        font-size: 14px;
        margin-top: 2em;
    }
</style>

<style lang="scss">
@import "../../../scss/abstracts/variables";
@import "../../../scss/abstracts/mixins";

body {
    &.profile-links--visible {
        .locations-filter.sticky.collapsed .filter-wrapper--toggle {
            margin-top: 24px;
            margin-bottom: 24px;

            @media #{$hd} {
                margin-top: 16px;
                margin-bottom: 16px;
            }
        }
    }
}

.views-content--supplier {
    .banner-intro-text {
        margin-top: 3rem;

        .col-xl-6 {
            flex-basis: 100% !important;
            max-width: 100% !important;
        }
    }
}


.locations {

    .gm-bundled-control-on-bottom {
        .gmnoprint {
            > div {
                box-shadow: none !important;
                background: none !important;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                > div {
                    display: none;
                }
            }
        }
        button {
            border-radius: 100%;
            background-color: #fff !important;
            width: 30px !important;
            height: 30px !important;

            img  {
                display: none !important;
            }

            background-size: 30px !important;
            background-image: url('/_resources/themes/colorsteel/dist/assets/images/map/zoom-in.svg') !important;

            &:last-child {
                background-image: url('/_resources/themes/colorsteel/dist/assets/images/map/zoom-out.svg') !important;
            }
        }
    }

    .gm-style {
        .cluster {
            display: flex;
            justify-content: center;
            align-items: center;

            img {
                width: 49px;
                height: 49px;
                display: block;
            }

            > div {
                padding-bottom: 7px;
                font-size: 14px;
                font-family: $font-primary-bold;
                right: 1px;
            }
        }

        .gm-style-iw-t {
            &::after {
                content: "";
                display: block;
                position: absolute;
                left: 150px;
                bottom: 80px;
                right: auto;
                top: auto;
                width: 0;
                height: 0;
                border: 20px solid transparent;
                border-left-color: #fff;
                border-right: 0;
                background: none;
                transform: none;
                box-shadow: none;

                @media (max-width:767px) {
                    border: 20px solid transparent;
                    border-top-color: #fff;
                    border-bottom: 0;
                    left: -20px;
                    bottom: -15px;
                }
            }
        }

        .gm-style-iw-tc {
            display: none;
        }

        .gm-style-iw-c {
            min-width: 300px !important;
            max-width: 300px !important;
            border-radius: 0;
            padding-top: 20px;
            padding-left: 20px;
        }

        .gm-style-iw-d {
            padding-right: 20px;
            padding-bottom: 10px;
        }

        button.gm-ui-hover-effect {
            top: 0 !important;
            right: 0 !important;
            width: 40px !important;
            height: 40px !important;
            opacity: 1;
            display: flex !important;
            justify-content: center;
            align-items: center;

            img {
                width: 24px !important;
                height: 24px !important;
                display: none !important;
            }

            &>span {
                display: none !important;
            }

            &::after {
                content: " ";
                display: block;
                width: 15px;
                height: 15px;
                background-position: center;
                background-size: 15px;
                background-image: url('/_resources/themes/colorsteel/dist/assets/images/icons/close.svg');
            }
        }

        .location {

            h4 {
                margin-top: 0;
                font-size: 1.3em;
            }

            .grouped {
                margin-top: 2em;
            }

            .website {
                margin-top: 2em;

                a {
                    text-decoration: underline;
                    font-family: $font-primary-med;
                }
            }
        }
    }

    .grouped {
        .service,
        .project-type {
            span {
                display: inline-block;

                &::after {
                    content: ", ";
                    display: inline-block;
                    margin-right: 5px;
                }

                &:last-child {
                    &::after {
                        display: none;
                    }
                }
            }
        }
    }
}
</style>
